module.exports = __webpack_public_path__ + "img/dashboard-menu.3001dc54.png";